import { render, staticRenderFns } from "./editWaybill.vue?vue&type=template&id=2afb3e4f&scoped=true"
import script from "./editWaybill.vue?vue&type=script&lang=js"
export * from "./editWaybill.vue?vue&type=script&lang=js"
import style0 from "./editWaybill.vue?vue&type=style&index=0&id=2afb3e4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb3e4f",
  null
  
)

export default component.exports